import React from 'react'
import { connect } from 'react-redux'

import PageHeader from '../../components/PageHeader'
import PageSection from '../../components/PageSection'
import WordpressImage from '../../components/WordpressImage'

export const SeedsIndexPage = ({
  data: { acf: { heroTitle, subTitle, description, experiments } },
  useMobileSectionImages
}) => {
  return (
    <main className='seedspage main fit mx-auto'>
      <PageHeader
        extraClass='js-dark-section'
        title={
          heroTitle && (
            <div className='page-header__title'>
              <img
                className='seedspage__seeds-icon mr1'
                src='/static/images/icons/seeds_logo.svg'
              />
              {heroTitle}
            </div>
          )
        }
      >
        {<h4>{subTitle}</h4>}
      </PageHeader>

      <PageSection extraClass='page-section--small'>
        <div className='col-10 mx-auto'>
          <p
            className='text-para mx-auto maxw-text center'
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </PageSection>
      <PageSection extraClass='page-section--small bg-light-grey-blue'>
        <div className='col-10 lg-col-12 mx-auto'>
          <div className='seedspage__experiments-list'>
            {experiments &&
              experiments.map((experiment, index) => {
                return (
                  <div
                    key={index}
                    className='center seedspage__experiments-list__item col-12 md-col-4 mx-auto'
                  >
                    <a
                      href={experiment.link.replace(
                        /wp(2)?\.snips\.ai/,
                        'snips.ai'
                      )}
                    >
                      <div className='seedspage__experiments-list__item__image mb2'>
                        <WordpressImage img={experiment.image} />
                      </div>
                      <h3 className='mb2'>{experiment.title}</h3>
                      <p
                        dangerouslySetInnerHTML={{ __html: experiment.content }}
                      />
                      <p className='seedspage__experiments-list__item__space' />
                    </a>
                  </div>
                )
              })}
          </div>
        </div>
      </PageSection>
    </main>
  )
}

function mapStateToProps ({ browser }) {
  return {
    useMobileSectionImages: browser.lessThan.lg
  }
}

export default connect(mapStateToProps)(SeedsIndexPage)



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/seeds/IndexPage.js